document.addEventListener("DOMContentLoaded", function () {
  // Initialize scrolling text with icons sliders only on mobile
  function initScrollingSliders() {
    // Only initialize on mobile screens (max-width: 749px)
    if (window.innerWidth > 749) {
      return;
    }

    document
      .querySelectorAll(".scrolling-text-with-icons__wrapper")
      .forEach(function (slider) {
        // Check if slider is already initialized
        if (slider.splide) {
          return;
        }

        const direction = slider.getAttribute("data-direction") || "right";
        const speedSetting = parseFloat(slider.getAttribute("data-speed")) || 1;
        const speed = direction === "left" ? -speedSetting : speedSetting; // Negative speed for left direction

        new Splide(slider, {
          type: "loop",
          pagination: false,
          arrows: false,
          autoWidth: true,
          clones: 3, // Create clones for seamless loop
          perPage: 1,
          perMove: 1,
          gap: "16px", // Match the CSS padding
          autoScroll: {
            speed: speed,
            autoStart: true,
            rewind: false,
            pauseOnHover: true,
            pauseOnFocus: true,
          },
        }).mount(window.splide.Extensions);
      });
  }

  // Initialize on load
  initScrollingSliders();

  // Re-initialize on resize
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      // Destroy existing sliders on desktop
      if (window.innerWidth > 749) {
        document
          .querySelectorAll(".scrolling-text-with-icons__wrapper")
          .forEach(function (slider) {
            if (slider.splide) {
              slider.splide.destroy();
            }
          });
      } else {
        // Initialize on mobile
        initScrollingSliders();
      }
    }, 100);
  });
});
